<template>
  <div class="groups-table-container">
    <div class="table-wrapper">
      <table class="modern-table">
        <thead>
          <tr>
            <th scope="col">
              <div class="th-content">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
                  <circle cx="12" cy="7" r="4"/>
                </svg>
                Fix név
              </div>
            </th>
            <th scope="col">
              <div class="th-content">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
                  <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
                </svg>
                Változtatható név
              </div>
            </th>
            <th scope="col">
              <div class="th-content">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
                  <line x1="16" y1="2" x2="16" y2="6"/>
                  <line x1="8" y1="2" x2="8" y2="6"/>
                  <line x1="3" y1="10" x2="21" y2="10"/>
                </svg>
                Nap
              </div>
            </th>
            <th scope="col">
              <div class="th-content">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <circle cx="12" cy="12" r="10"/>
                  <polyline points="12,6 12,12 16,14"/>
                </svg>
                Időpont
              </div>
            </th>
            <th scope="col">
              <div class="th-content">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <line x1="12" y1="1" x2="12" y2="23"/>
                  <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/>
                </svg>
                Havi díj
              </div>
            </th>
            <th scope="col">
              <div class="th-content">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <polyline points="3,6 5,6 21,6"/>
                  <path d="M19,6v14a2,2,0,0,1-2,2H7a2,2,0,0,1-2-2V6m3,0V4a2,2,0,0,1,2-2h4a2,2,0,0,1,2,2V6"/>
                </svg>
                Műveletek
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(grp, index) in groups" :key="grp.id" class="table-row">
            <td class="fixed-name">
              <div class="cell-content">
                <div class="group-icon">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
                    <circle cx="9" cy="7" r="4"/>
                    <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
                    <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
                  </svg>
                </div>
                <span class="group-name">{{ grp.def_name }}</span>
              </div>
            </td>
            <td class="editable-name">
              <div class="cell-content">
                <span
                  v-if="!grp.isEditing"
                  @dblclick="isAdmin && startEditing(index)"
                  class="editable-text"
                  :title="isAdmin ? 'Dupla kattintás a szerkesztéshez' : ''"
                >
                  {{ grp.name }}
                </span>
                <div v-else class="edit-input-wrapper">
                  <input
                    type="text"
                    v-model="grp.name"
                    @blur="stopEditing(index)"
                    @keyup.enter="stopEditing(index)"
                    @keyup.escape="cancelEditing(index)"
                    class="edit-input"
                    ref="editInput"
                    :placeholder="'Csoport neve'"
                  />
                  <div class="edit-actions">
                    <button class="edit-btn edit-btn--save" @click="stopEditing(index)" title="Mentés">
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <polyline points="20,6 9,17 4,12"/>
                      </svg>
                    </button>
                    <button class="edit-btn edit-btn--cancel" @click="cancelEditing(index)" title="Mégse">
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <line x1="18" y1="6" x2="6" y2="18"/>
                        <line x1="6" y1="6" x2="18" y2="18"/>
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            </td>
            <td class="schedule-day" @dblclick="isAdmin && openScheduleModal(index)" :title="isAdmin ? 'Dupla kattintás az időpont módosításához' : ''">
              <div class="cell-content">
                <span class="day-badge" v-for="(s, i) in scheduleList(grp)" :key="'d' + i">{{ s.day }}</span>
              </div>
            </td>
            <td class="schedule-time" @dblclick="isAdmin && openScheduleModal(index)" :title="isAdmin ? 'Dupla kattintás az időpont módosításához' : ''">
              <div class="cell-content">
                <span class="time-display" v-for="(s, i) in scheduleList(grp)" :key="'t' + i">
                  {{ s.time }}
                  <small v-if="s.frequency === 'biweekly'" style="font-size: 0.8em; color: #64748b; margin-left: 4px;">
                    (kéthetente<span v-if="s.start_date">, {{ s.start_date }}</span>)
                  </small>
                </span>
              </div>
            </td>
            <td class="monthly-price">
              <div class="cell-content">
                <span class="price-badge" style="background-color: #f1f5f9; color: #0f172a; padding: 4px 10px; border-radius: 6px; font-weight: 600;">
                  {{ grp.monthly_price ? grp.monthly_price + ' Ft' : 'Nincs megadva' }}
                </span>
              </div>
            </td>
            <td class="actions">
              <div class="cell-content flex-nowrap">
                <router-link :to="'/groups/' + grp.id" class="btn btn-info btn-sm me-1 text-white text-nowrap" title="Csoport tagjai és oktatói">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="me-1">
                    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
                    <circle cx="9" cy="7" r="4"/>
                  </svg>
                  Tagok & Tanárok
                </router-link>
                <button v-if="isAdmin" class="btn btn-secondary btn-sm me-1 text-nowrap" @click="openScheduleModal(index)" title="Időpont módosítása">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="me-1">
                    <circle cx="12" cy="12" r="10"/>
                    <polyline points="12,6 12,12 16,14"/>
                  </svg>
                  Időpont
                </button>
                <button v-if="isAdmin" class="btn btn-danger btn-sm text-nowrap" @click="delGrp(index)" title="Csoport törlése">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="me-1">
                    <polyline points="3,6 5,6 21,6"/>
                    <path d="M19,6v14a2,2,0,0,1-2,2H7a2,2,0,0,1-2-2V6m3,0V4a2,2,0,0,1,2-2h4a2,2,0,0,1,2,2V6"/>
                  </svg>
                  Törlés
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    
    <div v-if="groups.length === 0" class="empty-state">
      <div class="empty-icon">
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
          <circle cx="9" cy="7" r="4"/>
          <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
          <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
        </svg>
      </div>
      <h4>Nincsenek csoportok</h4>
      <p>Még nem hozott létre csoportokat</p>
    </div>

    <!-- Schedule Edit Modal -->
    <div v-if="editingScheduleGrpIndex !== null" class="modal-overlay" @click.self="closeScheduleModal">
      <div class="modal-card">
        <div class="modal-header">
          <h3>Időpont módosítása: {{ groups[editingScheduleGrpIndex].name }}</h3>
          <button class="close-btn" @click="closeScheduleModal">✕</button>
        </div>
        <div class="modal-body">
          <div v-for="(s, idx) in editingScheduleList" :key="idx" class="schedule-edit-row">
            <div class="schedule-inputs">
              <select class="modern-select select-day" v-model="s.day">
                <option value="1">Hétfő</option>
                <option value="2">Kedd</option>
                <option value="3">Szerda</option>
                <option value="4">Csütörtök</option>
                <option value="5">Péntek</option>
                <option value="6">Szombat</option>
                <option value="7">Vasárnap</option>
              </select>
              <input type="time" class="modern-input input-time" v-model="s.time" required />
              <select class="modern-select select-freq" v-model="s.frequency">
                <option value="weekly">Hetente</option>
                <option value="biweekly">Kéthetente</option>
              </select>
              <input
                v-if="s.frequency === 'biweekly'"
                type="date"
                class="modern-input input-date"
                v-model="s.start_date"
                :required="s.frequency === 'biweekly'"
                title="Kezdő dátum"
              />
            </div>
            <button type="button" class="btn-delete" v-if="editingScheduleList.length > 1" @click="removeScheduleRow(idx)" title="Eltávolítás">✕</button>
          </div>
          <button type="button" class="btn btn-outline-primary btn-sm mt-2 font-weight-bold" @click="addScheduleRow">+ További időpont</button>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary font-weight-bold" @click="saveSchedule">Mentés</button>
          <button type="button" class="btn btn-secondary" @click="closeScheduleModal">Mégse</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

const dayMap = {
  "1": "Hétfő",
  "2": "Kedd",
  "3": "Szerda",
  "4": "Csütörtök",
  "5": "Péntek",
  "6": "Szombat",
  "7": "Vasárnap",
};

const reverseDayMap = {
  "Hétfő": "1",
  "Kedd": "2",
  "Szerda": "3",
  "Csütörtök": "4",
  "Péntek": "5",
  "Szombat": "6",
  "Vasárnap": "7",
};

export default {
  data(){
    return {
      isAdmin: false,
      currentlyEditingIndex: null,
      originalName: '', // Store original name for cancel functionality
      editingScheduleGrpIndex: null,
      editingScheduleList: [],
    }
  },
  props: {
    groups: {
      type: Array,
      required: true,
    }
  },
  mounted() {
    this.isAdmin = this.$isAdmin ? this.$isAdmin() : false;
  },
  methods: {
    // Normalize a group's schedule (string, single object, or array) into a
    // list of {day, dayNum, time, frequency, start_date} slots for rendering.
    scheduleList(grp) {
      try {
        let s = grp.schedule;
        if (!s) return [];
        if (typeof s === 'string') s = JSON.parse(s);
        if (!Array.isArray(s)) s = [s];
        return s.filter(x => x && (x.day || x.set_day)).map(x => {
          const rawDay = String(x.day || x.set_day || '');
          let dayNum = rawDay;
          let dayName = rawDay;
          if (dayMap[rawDay]) {
            dayName = dayMap[rawDay];
            dayNum = rawDay;
          } else if (reverseDayMap[rawDay]) {
            dayNum = reverseDayMap[rawDay];
            dayName = rawDay;
          }
          return {
            day: dayName,
            dayNum: dayNum,
            time: x.time || x.set_time || '',
            frequency: x.frequency || 'weekly',
            start_date: x.start_date || '',
          };
        });
      } catch (e) {
        return [];
      }
    },
    openScheduleModal(index) {
      if (!this.isAdmin) return;
      this.editingScheduleGrpIndex = index;
      const grp = this.groups[index];
      const list = this.scheduleList(grp);
      if (list.length > 0) {
        this.editingScheduleList = list.map(item => ({
          day: item.dayNum || '1',
          time: item.time || '17:00',
          frequency: item.frequency || 'weekly',
          start_date: item.start_date || new Date().toISOString().split('T')[0],
        }));
      } else {
        this.editingScheduleList = [{
          day: '1',
          time: '17:00',
          frequency: 'weekly',
          start_date: new Date().toISOString().split('T')[0],
        }];
      }
    },
    addScheduleRow() {
      this.editingScheduleList.push({
        day: '1',
        time: '17:00',
        frequency: 'weekly',
        start_date: new Date().toISOString().split('T')[0],
      });
    },
    removeScheduleRow(idx) {
      if (this.editingScheduleList.length > 1) {
        this.editingScheduleList.splice(idx, 1);
      }
    },
    closeScheduleModal() {
      this.editingScheduleGrpIndex = null;
      this.editingScheduleList = [];
    },
    async saveSchedule() {
      if (this.editingScheduleGrpIndex === null || !this.isAdmin) return;
      const grp = this.groups[this.editingScheduleGrpIndex];
      const validSchedules = this.editingScheduleList
        .filter(s => s.day && s.time)
        .map(s => ({
          day: s.day,
          time: s.time,
          frequency: s.frequency || 'weekly',
          start_date: s.frequency === 'biweekly' ? (s.start_date || new Date().toISOString().split('T')[0]) : undefined
        }));
      if (validSchedules.length === 0) {
        alert('Legalább egy érvényes napot és időpontot meg kell adni!');
        return;
      }
      const payloadSchedule = JSON.stringify(validSchedules);
      try {
        const response = await axios.post(this.$BACKEND_HOST + '/api/updategroupschedule', {
          id: grp.id,
          schedule: payloadSchedule,
        });
        if (response.status === 200) {
          const updatedSched = response.data && response.data.schedule ? response.data.schedule : payloadSchedule;
          grp.schedule = updatedSched;
          this.$emit('update-items', this.groups);
          this.closeScheduleModal();
        }
      } catch (error) {
        console.error('Error updating group schedule:', error);
        alert('Hiba történt az időpont mentésekor!');
      }
    },
    startEditing(i) {
      if (!this.isAdmin) return;
      if (this.currentlyEditingIndex !== null) {
        this.stopEditing(this.currentlyEditingIndex);
      }
      this.currentlyEditingIndex = i;
      this.originalName = this.groups[i].name; // Store original name
      this.groups[i].isEditing = true;
      
      // Focus the input after the DOM updates
      this.$nextTick(() => {
        const inputs = this.$refs.editInput;
        if (inputs && inputs[i]) {
          inputs[i].focus();
          inputs[i].select();
        }
      });
    },
    async stopEditing(i) {
      const updatedItem = this.groups[i];
      this.currentlyEditingIndex = null;
      this.groups[i].isEditing = false;

      // Only update if the name actually changed
      if (updatedItem.name !== this.originalName && updatedItem.name.trim() !== '') {
        try {
          const response = await axios.post(this.$BACKEND_HOST + '/api/updategroupname', {
            id: updatedItem.id,
            name: updatedItem.name.trim(),
          });
          console.log('Item updated successfully:', response.data);
          this.$emit('update-items', this.groups);
        } catch (error) {
          console.error('Error updating item:', error);
          // Revert to original name on error
          updatedItem.name = this.originalName;
        }
      } else if (updatedItem.name.trim() === '') {
        // Revert to original name if empty
        updatedItem.name = this.originalName;
      }
      
      this.originalName = '';
    },
    cancelEditing(i) {
      // Revert to original name
      this.groups[i].name = this.originalName;
      this.groups[i].isEditing = false;
      this.currentlyEditingIndex = null;
      this.originalName = '';
    },
    async delGrp(i) {
      if (!this.isAdmin) return;
      if (!confirm('Biztosan törölni szeretné ezt a csoportot?')) {
        return;
      }
      
      const delId = this.groups[i].id;
      try {
        const response = await axios.post(this.$BACKEND_HOST + '/api/delgroup', {
          id: delId,
          name: "",
        });
        if(response.data["message"] == "done"){
          this.groups.splice(i,1);
          this.$emit('update-items', this.groups);
        }
      } catch (error) {
        console.error('Error deleting group:', error);
        alert('Hiba történt a csoport törlése során.');
      }
    }
  }
};
</script>

<style scoped>
/* Modern Groups Table Container */
.groups-table-container {
  background: var(--card-bg);
  border-radius: 16px;
  box-shadow: var(--shadow);
  border: 1px solid var(--color-border);
  overflow: hidden;
}

/* Table Header */
.table-header {
  padding: 1.5rem 2rem;
  background: var(--color-background-mute);
  border-bottom: 1px solid var(--color-border);
}

.table-header h3 {
  color: var(--color-heading);
  font-size: 1.25rem;
  font-weight: 600;
  margin: 0 0 0.25rem 0;
}

.table-header p {
  color: var(--color-text-muted);
  font-size: 0.875rem;
  margin: 0;
}

/* Table Wrapper */
.table-wrapper {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

/* Modern Table */
.modern-table {
  width: 100%;
  border-collapse: collapse;
  background: var(--card-bg);
}

.modern-table thead {
  background: var(--color-background-mute);
}

.modern-table th {
  padding: 1rem 1.5rem;
  text-align: left;
  font-weight: 600;
  color: var(--color-heading);
  font-size: 0.875rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-bottom: 2px solid var(--color-border);
  position: sticky;
  top: 0;
  z-index: 10;
}

.th-content {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.th-content svg {
  color: var(--primary-blue);
  flex-shrink: 0;
}

/* Table Rows */
.table-row {
  transition: all 0.2s ease;
  border-bottom: 1px solid var(--color-border);
}

.table-row:hover {
  background: var(--color-background-mute);
}

.table-row:last-child {
  border-bottom: none;
}

.modern-table td {
  padding: 1rem 1.5rem;
  vertical-align: middle;
  border-bottom: 1px solid var(--color-border);
}

.cell-content {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

/* Fixed Name Column */
.fixed-name .cell-content {
  gap: 0.75rem;
}

.group-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  background: linear-gradient(135deg, var(--primary-blue), var(--secondary-blue));
  border-radius: 8px;
  color: white;
  flex-shrink: 0;
}

.group-name {
  font-weight: 500;
  color: var(--color-text);
}

/* Editable Name Column */
.editable-text {
  cursor: pointer;
  padding: 0.5rem 0.75rem;
  border-radius: 6px;
  transition: all 0.2s ease;
  border: 2px solid transparent;
  display: inline-block;
  min-width: 120px;
}

.editable-text:hover {
  background: var(--color-background-mute);
  border-color: var(--color-border);
}

.edit-input-wrapper {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  min-width: 200px;
}

.edit-input {
  flex: 1;
  padding: 0.5rem 0.75rem;
  border: 2px solid var(--primary-blue);
  border-radius: 6px;
  background: var(--white);
  color: var(--color-text);
  font-size: 0.875rem;
  transition: all 0.2s ease;
}

.edit-input:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
}

.edit-actions {
  display: flex;
  gap: 0.25rem;
}

.edit-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.edit-btn--save {
  background: var(--success);
  color: white;
}

.edit-btn--save:hover {
  background: #059669;
  transform: scale(1.05);
}

.edit-btn--cancel {
  background: var(--error);
  color: white;
}

.edit-btn--cancel:hover {
  background: #dc2626;
  transform: scale(1.05);
}

/* Schedule Day Column */
.day-badge {
  display: inline-flex;
  align-items: center;
  padding: 0.25rem 0.75rem;
  background: linear-gradient(135deg, var(--primary-blue), var(--secondary-blue));
  color: white;
  border-radius: 20px;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* Schedule Time Column */
.time-display {
  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
  font-size: 0.875rem;
  font-weight: 500;
  color: var(--color-text);
  background: var(--color-background-mute);
  padding: 0.25rem 0.75rem;
  border-radius: 6px;
  border: 1px solid var(--color-border);
}

/* Actions Column */
.actions .cell-content {
  justify-content: flex-start;
  white-space: nowrap;
}

/* Button styles moved to components.css */

/* Empty State */
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3rem 2rem;
  text-align: center;
}

.empty-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80px;
  height: 80px;
  background: var(--color-background-mute);
  border-radius: 50%;
  color: var(--color-text-muted);
  margin-bottom: 1.5rem;
  box-shadow: var(--shadow-sm);
}

.empty-state h4 {
  color: var(--color-heading);
  font-size: 1.25rem;
  font-weight: 600;
  margin: 0 0 0.5rem 0;
}

.empty-state p {
  color: var(--color-text-muted);
  font-size: 0.875rem;
  margin: 0;
}

/* Responsive Design */
@media (max-width: 768px) {
  .table-header {
    padding: 1.25rem 1.5rem;
  }
  
  .table-header h3 {
    font-size: 1.125rem;
  }
  
  .modern-table th,
  .modern-table td {
    padding: 0.75rem 1rem;
  }
  
  .modern-table th {
    font-size: 0.8rem;
  }
  
  .th-content {
    gap: 0.25rem;
  }
  
  .th-content svg {
    width: 14px;
    height: 14px;
  }
  
  .group-icon {
    width: 28px;
    height: 28px;
  }
  
  .edit-input-wrapper {
    min-width: 150px;
  }
  
  .edit-input {
    font-size: 0.8rem;
    padding: 0.375rem 0.5rem;
  }
  
  .edit-btn {
    width: 24px;
    height: 24px;
  }
  
  .day-badge {
    font-size: 0.7rem;
    padding: 0.2rem 0.5rem;
  }
  
  .time-display {
    font-size: 0.8rem;
    padding: 0.2rem 0.5rem;
  }
  
  .btn-sm {
    padding: 0.25rem 0.5rem;
    font-size: 0.75rem;
  }
  
  .empty-state {
    padding: 2rem 1.5rem;
  }
  
  .empty-icon {
    width: 64px;
    height: 64px;
  }
  
  .empty-state h4 {
    font-size: 1.125rem;
  }
}

@media (max-width: 480px) {
  .table-header {
    padding: 1rem;
  }
  
  .modern-table th,
  .modern-table td {
    padding: 0.5rem 0.6rem;
  }
  
  .modern-table th {
    font-size: 0.75rem;
    white-space: nowrap;
  }
  
  .th-content span {
    font-size: 0.75rem;
  }
  
  .th-content svg {
    width: 14px;
    height: 14px;
  }
  
  .group-icon {
    width: 24px;
    height: 24px;
  }
  
  .group-name {
    font-size: 0.875rem;
  }
  
  .editable-text {
    min-width: 80px;
    padding: 0.375rem 0.5rem;
    font-size: 0.8rem;
  }
  
  .edit-input-wrapper {
    min-width: 120px;
  }
  
  .edit-input {
    font-size: 0.75rem;
    padding: 0.25rem 0.375rem;
  }
  
  .edit-btn {
    width: 20px;
    height: 20px;
  }
  
  .day-badge {
    font-size: 0.65rem;
    padding: 0.15rem 0.375rem;
  }
  
  .time-display {
    font-size: 0.75rem;
    padding: 0.15rem 0.375rem;
  }
  
  .btn-sm {
    padding: 0.2rem 0.375rem;
    font-size: 0.7rem;
  }
  
  .btn-sm span {
    display: none;
  }
  
  .empty-state {
    padding: 1.5rem 1rem;
  }
  
  .empty-icon {
    width: 56px;
    height: 56px;
  }
  
  .empty-state h4 {
    font-size: 1rem;
  }
  
  .empty-state p {
    font-size: 0.8rem;
  }
}

/* Dark mode adjustments */
@media (prefers-color-scheme: dark) {
  .edit-input {
    background: var(--gray-700);
    color: var(--gray-100);
  }
  
  .time-display {
    background: var(--gray-700);
    color: var(--gray-100);
    border-color: var(--gray-600);
  }
}

/* Modal Overlay & Schedule Editor Floating Menu Styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(15, 23, 42, 0.65);
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 99999;
}

.modal-card {
  background: #ffffff;
  border-radius: 16px;
  width: 90%;
  max-width: 500px;
  padding: 1.75rem;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  border: 1px solid #e2e8f0;
  color: #0f172a;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.25rem;
  padding-bottom: 0.75rem;
  border-bottom: 1px solid #e2e8f0;
}

.modal-header h3 {
  font-size: 1.2rem;
  margin: 0;
  font-weight: 700;
  color: #0f172a;
}

.close-btn {
  background: #f1f5f9;
  border: none;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  font-size: 1.1rem;
  cursor: pointer;
  color: #64748b;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}
.close-btn:hover {
  background: #e2e8f0;
  color: #0f172a;
}

.modal-body {
  padding: 0.5rem 0;
}

.schedule-edit-row {
  display: flex;
  gap: 0.5rem;
  align-items: center;
  margin-bottom: 0.85rem;
  padding-bottom: 0.75rem;
  border-bottom: 1px dashed #e2e8f0;
}

.schedule-inputs {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  flex: 1;
}

.schedule-edit-row .modern-select,
.schedule-edit-row .modern-input {
  padding: 0.5rem 0.65rem;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  background-color: #ffffff;
  color: #0f172a;
  font-size: 0.9rem;
  font-weight: 500;
}

.select-day {
  flex: 1 1 120px;
  min-width: 100px;
}

.input-time {
  flex: 0 1 110px;
  min-width: 90px;
}

.select-freq {
  flex: 0 1 120px;
  min-width: 100px;
}

.input-date {
  flex: 1 1 130px;
  min-width: 110px;
}

.btn-delete {
  background: #fee2e2;
  color: #ef4444;
  border: 1px solid #fca5a5;
  border-radius: 8px;
  width: 36px;
  height: 36px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-weight: bold;
  transition: all 0.2s ease;
  flex-shrink: 0;
}
.btn-delete:hover {
  background: #ef4444;
  color: #ffffff;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
  margin-top: 1.5rem;
  padding-top: 1rem;
  border-top: 1px solid #e2e8f0;
}

@media (max-width: 576px) {
  .modal-card {
    width: 95%;
    max-height: 90vh;
    overflow-y: auto;
    padding: 1.25rem;
  }

  .select-day, .input-time, .select-freq, .input-date {
    flex: 1 1 calc(50% - 0.5rem);
    width: 100%;
  }
}
</style>